import styled, { css } from 'styled-components'

const COR_ABA = { intimacoes: '#2563eb', prazos: '#d97706', revisoes: '#7c3aed', movimentacoes: '#0d9488', sistema: '#64748b' }

export const Sino = styled.button`
  all: unset;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #fff;
  &:hover { background: rgba(255, 255, 255, 0.1); }
  &:focus-visible { outline: 2px solid #ffd966; }
`

export const Topo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--yrm-border);
  overflow-x: auto;
  .ant-segmented { flex: none; }
`

export const Contador = styled.span`
  margin-left: 4px;
  font-size: 12px;
  font-weight: 700;
  color: var(--yrm-link);
`

export const Filtro = styled.button`
  all: unset;
  cursor: pointer;
  flex: none;
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 12px;
  border: 1px solid var(--yrm-border);
  color: var(--yrm-text-2);
  ${(p) => p.$ativo && css`background: var(--yrm-tint-azul); border-color: #93c5fd; color: #1d4ed8;`}
`

export const Lista = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`

export const Grupo = styled.section`
  .rotulo {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 8px 16px 4px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--yrm-text-3);
    background: var(--yrm-surface);
  }
  ${(p) => p.$destaque && css`
    .rotulo { color: #ef4444; }
  `}
`

export const Item = styled.button`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  width: 100%;
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) 16px;
  gap: 10px;
  align-items: start;
  padding: 10px 16px;
  border-left: 3px solid transparent;
  &:hover { background: var(--yrm-surface-2); }
  &:focus-visible { outline: 2px solid #2a78d6; outline-offset: -2px; }

  .corpo { min-width: 0; }
  .titulo { font-size: 14px; color: var(--yrm-text); font-weight: ${(p) => (p.$lida ? 400 : 600)}; }
  .descricao {
    margin-top: 2px;
    font-size: 13px;
    color: var(--yrm-text-2);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .meta { margin-top: 4px; font-size: 12px; color: var(--yrm-text-4); display: flex; align-items: center; flex-wrap: wrap; }
  .abrir { margin-left: 4px; color: var(--yrm-link); }

  ${(p) => p.$prioridade === 'urgente' && !p.$lida && css`border-left-color: #dc2626;`}
  ${(p) => p.$lida && css`.titulo, .descricao { color: var(--yrm-text-3); }`}
`

export const Icone = styled.span`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: ${(p) => COR_ABA[p.$aba] || 'var(--yrm-text-3)'};
  background: ${(p) => `${COR_ABA[p.$aba] || '#64748b'}1a`};
`

export const Ponto = styled.span`
  margin-top: 6px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  cursor: pointer;
  background: ${(p) => (p.$lida ? 'transparent' : '#2563eb')};
  border: 2px solid ${(p) => (p.$lida ? '#cbd5e1' : '#2563eb')};
`

export const Rodape = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 16px;
  border-top: 1px solid var(--yrm-border);
`
